import { MultiSelect } from '@hakimo-ui/hakimo/ui-elements';
import { useUser } from '@hakimo-ui/hakimo/util';
import { Selectable } from '@hakimo-ui/shared/ui-base';
import { useCallback, useMemo } from 'react';

interface Props {
  value: Selectable[];
  onChange: (value: Selectable[]) => void;
}

function TenantIdFilter(props: Props) {
  const { value, onChange } = props;
  const user = useUser();

  const tenantSelectables = useMemo(() => {
    const seen = new Set<string>();
    const items: Selectable[] = [];
    const addTenant = (t: { id: string; name: string }) => {
      if (!seen.has(t.id)) {
        seen.add(t.id);
        items.push({ id: t.id, name: t.name });
      }
    };
    addTenant(user.tenant);
    user.mspTenants?.forEach(addTenant);
    user.visionTenants?.forEach(addTenant);
    return items.sort((a, b) => a.name.localeCompare(b.name));
  }, [user]);

  const resolvedValue = useMemo(
    () =>
      value.map((v) => {
        const match = tenantSelectables.find((t) => t.id === v.id);
        return match ?? v;
      }),
    [value, tenantSelectables]
  );

  const getItems = useCallback(
    (query: string) => {
      if (!query) return tenantSelectables;
      return tenantSelectables.filter((t) =>
        t.name.toLowerCase().includes(query.toLowerCase())
      );
    },
    [tenantSelectables]
  );

  return (
    <MultiSelect
      label="Tenant"
      value={resolvedValue}
      onChange={onChange}
      getItems={getItems}
      displayValue={(item) => item?.name}
      id={(item) => item.id}
    />
  );
}

export default TenantIdFilter;
